module.exports = __webpack_public_path__ + "static/media/check-icon.5ab8f982.png";